import axios from "../utils/axios";
import Swal from 'sweetalert2';


export const login = (async (cb, email, password) => {
    try {
        const { data } = await axios.post(`/login`, {
            email,
            password
        });
        cb(data);

    } catch (error) {
        if (error.response) {
            console.error(error.response)
            Swal.fire({ title: `${error.response.data.message}`, icon: "error" });
        }

    };

});


export const register = (async (data) => {
    try {
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        }
        await axios.post(`/signup`, data, config);
        Swal.fire({ title: "New user added succesfully!", icon: "success" });

    }
    catch (error) {
        console.error("Error in singing up");
        Swal.fire(error.response.data.message);
    }

});

export const changePassword = async (data, user) => {
    try {
        const config = {
            headers: {
                "Content-Type": "application/json"
            }
        }
        await axios.put(`/change-password/${user.id}`, data, config);
        Swal.fire({ title: "Password changed successfully", icon: "success" });
    }
    catch (error) {
        console.error("Error in Changing Password.");
        console.error(error.response.data.message);
        Swal.fire({ title: `${error.response.data.message}`, icon: "error" });
    }
}

